import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContextualHelpNotifierService {
  contextualHelpNotifierSubject = new Subject<string>();
  data = this.contextualHelpNotifierSubject.asObservable();

  contextualHelpChanged(contextualHelpName: string): void {
    this.contextualHelpNotifierSubject.next(contextualHelpName);
  }
}
